import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import CustomUrlComponent from "../../components/CustomUrl/customUrlComponent"
import SideBarForRole7 from "../../components/sidebar/SideBarForRole7"
import NavbarForRole7 from "../../components/navbar/NavbarForRole7"

const CustomUrlPage = () => {
  return (
    <div className="list">
      <SideBarForRole7/>
      <div className="listContainer">
        <NavbarForRole7/>
        <CustomUrlComponent/>
      </div>
    </div>
  )
}

export default CustomUrlPage